<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                     <h2 class="mb-4">
                        John
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To teach that Jesus is God and that he provides all we need for this life and the next.
                        </li>
                        <li>
                            To teach that Jesus is the one who offers life to all who trust in him.
                        </li>
                        <li>
                            To teach that Jesus is the Messiah who reverses the curse of sin and death.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series covers the seven signs which Jesus performed in seven lessons. Each sign and each lesson therefore aims to reveal more of Jesus’ identity and how people responded to that truth in one of two ways:
                    </p>
                    <p>
                        Trust in Jesus – From the very first sign Jesus’ glory was displayed and the disciples rightly put their faith in him (week 1). As they came to know him better their faith developed (week 5), just as it did for the official and his family, for Mary and Martha and for the blind man (weeks 2, 6 and 7). Belief and trust in Jesus may start out small, but a growing understanding of who he is and what he has and will do for his people always results in a stronger and fuller faith.
                    </p>
                    <p>
                        Rejection of Jesus – Although the same signs were performed in the sight of many, not everyone responded as they should. The Jewish religious leaders openly hated Jesus and plotted to kill him (weeks 3, 6 and 7), but rejecting him is not always so straightforward. The lame man seemed to obey Jesus initially, but betrayed him to the angry Jewish leaders (week 3); the hungry crowd wanted to make Jesus king by force, but were only interested in what he could give them (week 4); the Pharisees desperately tried to deny the truth of what had happened and even persecuted Jesus’ followers (week 6). All of these, however, still end in rejection.
                    </p>
                    <p>
                        Through these signs we gain a richer understanding of who Jesus is and a warning also. Knowing who Jesus is demands a response, but only one is right. These signs should lead us to trust Jesus as our glorious king, great rescuer, generous provider and life-giving God. Nothing less will do.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Wine at the Wedding (John 2:1-11)
                    </p>
                    <p>
                        Lesson 2 - Healing away from Home (John 4:43-54)
                    </p>
                    <p>
                        Lesson 3 - The Paralytic at the Pool (John 5:1-18)
                    </p>
                    <p>
                        Lesson 4 - Feeding the Five-thousand (John 6:1-15, 25-59)
                    </p>
                    <p>
                        Lesson 5 - Walking on Water (John 6:16-24)
                    </p>
                    <p>
                        Lesson 6 - Blind Belief (John 9:1-41)
                    </p>
                    <p>
                        Lesson 7 - Life for Lazarus (John 11:1-53)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "John",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - John`,
            meta: [
                {
                    name: 'description',
                    content: "To teach that Jesus is God and that he provides all we need for this life and the next.",
                },
            ],
        };
    },
};
</script>
